module.exports = __webpack_public_path__ + "static/media/content_rating_p.f2d5d8ec.svg";